
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M5.5.75h13a1 1 0 011 1v21.5h-15V1.75a1 1 0 011-1zM15.75 11.625a.375.375 0 01.375.375M15.375 12a.375.375 0 01.375-.375M15.75 12.375a.375.375 0 01-.375-.375M16.125 12a.375.375 0 01-.375.375M1.5 23.25h21"}})])
          )
        }
      }
    